/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1ProgrammeRequest } from './V1ProgrammeRequest'
import {
    V1ProgrammeRequestFromJSON,
    V1ProgrammeRequestFromJSONTyped,
    V1ProgrammeRequestToJSON,
    V1ProgrammeRequestToJSONTyped
} from './V1ProgrammeRequest'
import type { V1Message } from './V1Message'
import {
    V1MessageFromJSON,
    V1MessageFromJSONTyped,
    V1MessageToJSON,
    V1MessageToJSONTyped
} from './V1Message'

/**
 * SSE event payload for real-time request updates
 * @export
 * @interface V1RequestEvent
 */
export interface V1RequestEvent {
    /**
     *
     */
    type?: V1RequestEventTypeEnum
    /**
     *
     */
    request?: V1ProgrammeRequest
    /**
     *
     */
    message?: V1Message
    /**
     *
     */
    keepalive?: string
}

/**
 * @export
 */
export const V1RequestEventTypeEnum = {
    StatusChange: 'status_change',
    NewMessage: 'new_message',
    Keepalive: 'keepalive'
} as const
export type V1RequestEventTypeEnum =
    (typeof V1RequestEventTypeEnum)[keyof typeof V1RequestEventTypeEnum]

/**
 * Check if a given object implements the V1RequestEvent interface.
 */
export function instanceOfV1RequestEvent(
    value: object
): value is V1RequestEvent {
    return true
}

export function V1RequestEventFromJSON(json: any): V1RequestEvent {
    return V1RequestEventFromJSONTyped(json, false)
}

export function V1RequestEventFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1RequestEvent {
    if (json == null) {
        return json
    }
    return {
        type: json['type'] == null ? undefined : json['type'],
        request:
            json['request'] == null
                ? undefined
                : V1ProgrammeRequestFromJSON(json['request']),
        message:
            json['message'] == null
                ? undefined
                : V1MessageFromJSON(json['message']),
        keepalive: json['keepalive'] == null ? undefined : json['keepalive']
    }
}

export function V1RequestEventToJSON(json: any): V1RequestEvent {
    return V1RequestEventToJSONTyped(json, false)
}

export function V1RequestEventToJSONTyped(
    value?: V1RequestEvent | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        type: value['type'],
        request: V1ProgrammeRequestToJSON(value['request']),
        message: V1MessageToJSON(value['message']),
        keepalive: value['keepalive']
    }
}
